const article15 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.4;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const article15Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.4,
  fontWeight: 400,
  fontStyle: "normal"
};
const article17 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.4;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const article17Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.4,
  fontWeight: 400,
  fontStyle: "normal"
};
const articleBold15 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.4;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const articleBold15Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.4,
  fontWeight: 700,
  fontStyle: "normal"
};
const articleBold17 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.4;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const articleBold17Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.4,
  fontWeight: 700,
  fontStyle: "normal"
};
const articleBoldItalic15 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.4;
	font-weight: 700;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const articleBoldItalic15Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.4,
  fontWeight: 700,
  fontStyle: "italic"
};
const articleBoldItalic17 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.4;
	font-weight: 700;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const articleBoldItalic17Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.4,
  fontWeight: 700,
  fontStyle: "italic"
};
const articleItalic15 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.4;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const articleItalic15Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.4,
  fontWeight: 400,
  fontStyle: "italic"
};
const articleItalic17 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.4;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const articleItalic17Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.4,
  fontWeight: 400,
  fontStyle: "italic"
};
const headlineBold14 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 0.875rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const headlineBold14Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "0.875rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};
const headlineBold15 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const headlineBold15Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};
const headlineBold17 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const headlineBold17Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};
const headlineBold20 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.25rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const headlineBold20Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.25rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};
const headlineBold24 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.5rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const headlineBold24Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.5rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};
const headlineBold28 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.75rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const headlineBold28Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.75rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};
const headlineBold34 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 2.125rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 4px;
`;
const headlineBold34Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "2.125rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};
const headlineBold42 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 2.625rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 5px;
`;
const headlineBold42Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "2.625rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};
const headlineBold50 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 3.125rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 6px;
`;
const headlineBold50Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "3.125rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};
const headlineBold64 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 4rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 6px;
`;
const headlineBold64Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "4rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};
const headlineLight14 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 0.875rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const headlineLight14Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "0.875rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "normal"
};
const headlineLight15 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const headlineLight15Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "normal"
};
const headlineLight17 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const headlineLight17Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "normal"
};
const headlineLight20 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.25rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const headlineLight20Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.25rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "normal"
};
const headlineLight24 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.5rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const headlineLight24Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.5rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "normal"
};
const headlineLight28 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.75rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const headlineLight28Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.75rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "normal"
};
const headlineLight34 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 2.125rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: normal;
	--source-text-decoration-thickness: 4px;
`;
const headlineLight34Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "2.125rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "normal"
};
const headlineLight42 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 2.625rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: normal;
	--source-text-decoration-thickness: 5px;
`;
const headlineLight42Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "2.625rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "normal"
};
const headlineLight50 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 3.125rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: normal;
	--source-text-decoration-thickness: 6px;
`;
const headlineLight50Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "3.125rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "normal"
};
const headlineLight64 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 4rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: normal;
	--source-text-decoration-thickness: 6px;
`;
const headlineLight64Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "4rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "normal"
};
const headlineLightItalic14 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 0.875rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const headlineLightItalic14Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "0.875rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "italic"
};
const headlineLightItalic15 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const headlineLightItalic15Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "italic"
};
const headlineLightItalic17 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const headlineLightItalic17Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "italic"
};
const headlineLightItalic20 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.25rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: italic;
	--source-text-decoration-thickness: 3px;
`;
const headlineLightItalic20Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.25rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "italic"
};
const headlineLightItalic24 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.5rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: italic;
	--source-text-decoration-thickness: 3px;
`;
const headlineLightItalic24Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.5rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "italic"
};
const headlineLightItalic28 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.75rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: italic;
	--source-text-decoration-thickness: 3px;
`;
const headlineLightItalic28Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.75rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "italic"
};
const headlineLightItalic34 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 2.125rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: italic;
	--source-text-decoration-thickness: 4px;
`;
const headlineLightItalic34Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "2.125rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "italic"
};
const headlineLightItalic42 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 2.625rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: italic;
	--source-text-decoration-thickness: 5px;
`;
const headlineLightItalic42Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "2.625rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "italic"
};
const headlineLightItalic50 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 3.125rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: italic;
	--source-text-decoration-thickness: 6px;
`;
const headlineLightItalic50Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "3.125rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "italic"
};
const headlineLightItalic64 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 4rem;
	line-height: 1.15;
	font-weight: 300;
	font-style: italic;
	--source-text-decoration-thickness: 6px;
`;
const headlineLightItalic64Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "4rem",
  lineHeight: 1.15,
  fontWeight: 300,
  fontStyle: "italic"
};
const headlineMedium14 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 0.875rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const headlineMedium14Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "0.875rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "normal"
};
const headlineMedium15 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const headlineMedium15Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "normal"
};
const headlineMedium17 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const headlineMedium17Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "normal"
};
const headlineMedium20 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.25rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const headlineMedium20Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.25rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "normal"
};
const headlineMedium24 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.5rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const headlineMedium24Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.5rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "normal"
};
const headlineMedium28 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.75rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const headlineMedium28Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.75rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "normal"
};
const headlineMedium34 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 2.125rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: normal;
	--source-text-decoration-thickness: 4px;
`;
const headlineMedium34Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "2.125rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "normal"
};
const headlineMedium42 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 2.625rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: normal;
	--source-text-decoration-thickness: 5px;
`;
const headlineMedium42Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "2.625rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "normal"
};
const headlineMedium50 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 3.125rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: normal;
	--source-text-decoration-thickness: 6px;
`;
const headlineMedium50Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "3.125rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "normal"
};
const headlineMedium64 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 4rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: normal;
	--source-text-decoration-thickness: 6px;
`;
const headlineMedium64Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "4rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "normal"
};
const headlineMediumItalic14 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 0.875rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const headlineMediumItalic14Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "0.875rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "italic"
};
const headlineMediumItalic15 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const headlineMediumItalic15Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "italic"
};
const headlineMediumItalic17 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const headlineMediumItalic17Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "italic"
};
const headlineMediumItalic20 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.25rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: italic;
	--source-text-decoration-thickness: 3px;
`;
const headlineMediumItalic20Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.25rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "italic"
};
const headlineMediumItalic24 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.5rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: italic;
	--source-text-decoration-thickness: 3px;
`;
const headlineMediumItalic24Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.5rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "italic"
};
const headlineMediumItalic28 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 1.75rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: italic;
	--source-text-decoration-thickness: 3px;
`;
const headlineMediumItalic28Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "1.75rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "italic"
};
const headlineMediumItalic34 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 2.125rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: italic;
	--source-text-decoration-thickness: 4px;
`;
const headlineMediumItalic34Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "2.125rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "italic"
};
const headlineMediumItalic42 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 2.625rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: italic;
	--source-text-decoration-thickness: 5px;
`;
const headlineMediumItalic42Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "2.625rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "italic"
};
const headlineMediumItalic50 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 3.125rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: italic;
	--source-text-decoration-thickness: 6px;
`;
const headlineMediumItalic50Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "3.125rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "italic"
};
const headlineMediumItalic64 = `
	font-family: "GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif;
	font-size: 4rem;
	line-height: 1.15;
	font-weight: 500;
	font-style: italic;
	--source-text-decoration-thickness: 6px;
`;
const headlineMediumItalic64Object = {
  fontFamily: '"GH Guardian Headline", "Guardian Egyptian Web", Georgia, serif',
  fontSize: "4rem",
  lineHeight: 1.15,
  fontWeight: 500,
  fontStyle: "italic"
};
const textEgyptian14 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 0.875rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textEgyptian14Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "0.875rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "normal"
};
const textEgyptian15 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textEgyptian15Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "normal"
};
const textEgyptian17 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textEgyptian17Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "normal"
};
const textEgyptianBold14 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 0.875rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textEgyptianBold14Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "0.875rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "normal"
};
const textEgyptianBold15 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textEgyptianBold15Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "normal"
};
const textEgyptianBold17 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textEgyptianBold17Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "normal"
};
const textEgyptianBoldItalic14 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 0.875rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const textEgyptianBoldItalic14Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "0.875rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "italic"
};
const textEgyptianBoldItalic15 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const textEgyptianBoldItalic15Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "italic"
};
const textEgyptianBoldItalic17 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const textEgyptianBoldItalic17Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "italic"
};
const textEgyptianItalic14 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 0.875rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const textEgyptianItalic14Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "0.875rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "italic"
};
const textEgyptianItalic15 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 0.9375rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const textEgyptianItalic15Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "0.9375rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "italic"
};
const textEgyptianItalic17 = `
	font-family: GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif;
	font-size: 1.0625rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const textEgyptianItalic17Object = {
  fontFamily: 'GuardianTextEgyptian, "Guardian Text Egyptian Web", Georgia, serif',
  fontSize: "1.0625rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "italic"
};
const textSans12 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 0.75rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textSans12Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "0.75rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "normal"
};
const textSans14 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 0.875rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textSans14Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "0.875rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "normal"
};
const textSans15 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 0.9375rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textSans15Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "0.9375rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "normal"
};
const textSans17 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 1.0625rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textSans17Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "1.0625rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "normal"
};
const textSans20 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 1.25rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const textSans20Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "1.25rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "normal"
};
const textSans24 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 1.5rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const textSans24Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "1.5rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "normal"
};
const textSans28 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 1.75rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const textSans28Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "1.75rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "normal"
};
const textSans34 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 2.125rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: normal;
	--source-text-decoration-thickness: 4px;
`;
const textSans34Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "2.125rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "normal"
};
const textSansBold12 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 0.75rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textSansBold12Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "0.75rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "normal"
};
const textSansBold14 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 0.875rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textSansBold14Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "0.875rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "normal"
};
const textSansBold15 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 0.9375rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textSansBold15Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "0.9375rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "normal"
};
const textSansBold17 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 1.0625rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 2px;
`;
const textSansBold17Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "1.0625rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "normal"
};
const textSansBold20 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 1.25rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const textSansBold20Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "1.25rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "normal"
};
const textSansBold24 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 1.5rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const textSansBold24Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "1.5rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "normal"
};
const textSansBold28 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 1.75rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 3px;
`;
const textSansBold28Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "1.75rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "normal"
};
const textSansBold34 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 2.125rem;
	line-height: 1.3;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 4px;
`;
const textSansBold34Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "2.125rem",
  lineHeight: 1.3,
  fontWeight: 700,
  fontStyle: "normal"
};
const textSansItalic12 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 0.75rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const textSansItalic12Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "0.75rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "italic"
};
const textSansItalic14 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 0.875rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const textSansItalic14Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "0.875rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "italic"
};
const textSansItalic15 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 0.9375rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const textSansItalic15Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "0.9375rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "italic"
};
const textSansItalic17 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 1.0625rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 2px;
`;
const textSansItalic17Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "1.0625rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "italic"
};
const textSansItalic20 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 1.25rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 3px;
`;
const textSansItalic20Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "1.25rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "italic"
};
const textSansItalic24 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 1.5rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 3px;
`;
const textSansItalic24Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "1.5rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "italic"
};
const textSansItalic28 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 1.75rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 3px;
`;
const textSansItalic28Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "1.75rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "italic"
};
const textSansItalic34 = `
	font-family: GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;
	font-size: 2.125rem;
	line-height: 1.3;
	font-weight: 400;
	font-style: italic;
	--source-text-decoration-thickness: 4px;
`;
const textSansItalic34Object = {
  fontFamily: 'GuardianTextSans, "Guardian Text Sans Web", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
  fontSize: "2.125rem",
  lineHeight: 1.3,
  fontWeight: 400,
  fontStyle: "italic"
};
const titlepiece42 = `
	font-family: "GT Guardian Titlepiece", Georgia, serif;
	font-size: 2.625rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 5px;
`;
const titlepiece42Object = {
  fontFamily: '"GT Guardian Titlepiece", Georgia, serif',
  fontSize: "2.625rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};
const titlepiece50 = `
	font-family: "GT Guardian Titlepiece", Georgia, serif;
	font-size: 3.125rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 6px;
`;
const titlepiece50Object = {
  fontFamily: '"GT Guardian Titlepiece", Georgia, serif',
  fontSize: "3.125rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};
const titlepiece70 = `
	font-family: "GT Guardian Titlepiece", Georgia, serif;
	font-size: 4.375rem;
	line-height: 1.15;
	font-weight: 700;
	font-style: normal;
	--source-text-decoration-thickness: 6px;
`;
const titlepiece70Object = {
  fontFamily: '"GT Guardian Titlepiece", Georgia, serif',
  fontSize: "4.375rem",
  lineHeight: 1.15,
  fontWeight: 700,
  fontStyle: "normal"
};

export { article15, article15Object, article17, article17Object, articleBold15, articleBold15Object, articleBold17, articleBold17Object, articleBoldItalic15, articleBoldItalic15Object, articleBoldItalic17, articleBoldItalic17Object, articleItalic15, articleItalic15Object, articleItalic17, articleItalic17Object, headlineBold14, headlineBold14Object, headlineBold15, headlineBold15Object, headlineBold17, headlineBold17Object, headlineBold20, headlineBold20Object, headlineBold24, headlineBold24Object, headlineBold28, headlineBold28Object, headlineBold34, headlineBold34Object, headlineBold42, headlineBold42Object, headlineBold50, headlineBold50Object, headlineBold64, headlineBold64Object, headlineLight14, headlineLight14Object, headlineLight15, headlineLight15Object, headlineLight17, headlineLight17Object, headlineLight20, headlineLight20Object, headlineLight24, headlineLight24Object, headlineLight28, headlineLight28Object, headlineLight34, headlineLight34Object, headlineLight42, headlineLight42Object, headlineLight50, headlineLight50Object, headlineLight64, headlineLight64Object, headlineLightItalic14, headlineLightItalic14Object, headlineLightItalic15, headlineLightItalic15Object, headlineLightItalic17, headlineLightItalic17Object, headlineLightItalic20, headlineLightItalic20Object, headlineLightItalic24, headlineLightItalic24Object, headlineLightItalic28, headlineLightItalic28Object, headlineLightItalic34, headlineLightItalic34Object, headlineLightItalic42, headlineLightItalic42Object, headlineLightItalic50, headlineLightItalic50Object, headlineLightItalic64, headlineLightItalic64Object, headlineMedium14, headlineMedium14Object, headlineMedium15, headlineMedium15Object, headlineMedium17, headlineMedium17Object, headlineMedium20, headlineMedium20Object, headlineMedium24, headlineMedium24Object, headlineMedium28, headlineMedium28Object, headlineMedium34, headlineMedium34Object, headlineMedium42, headlineMedium42Object, headlineMedium50, headlineMedium50Object, headlineMedium64, headlineMedium64Object, headlineMediumItalic14, headlineMediumItalic14Object, headlineMediumItalic15, headlineMediumItalic15Object, headlineMediumItalic17, headlineMediumItalic17Object, headlineMediumItalic20, headlineMediumItalic20Object, headlineMediumItalic24, headlineMediumItalic24Object, headlineMediumItalic28, headlineMediumItalic28Object, headlineMediumItalic34, headlineMediumItalic34Object, headlineMediumItalic42, headlineMediumItalic42Object, headlineMediumItalic50, headlineMediumItalic50Object, headlineMediumItalic64, headlineMediumItalic64Object, textEgyptian14, textEgyptian14Object, textEgyptian15, textEgyptian15Object, textEgyptian17, textEgyptian17Object, textEgyptianBold14, textEgyptianBold14Object, textEgyptianBold15, textEgyptianBold15Object, textEgyptianBold17, textEgyptianBold17Object, textEgyptianBoldItalic14, textEgyptianBoldItalic14Object, textEgyptianBoldItalic15, textEgyptianBoldItalic15Object, textEgyptianBoldItalic17, textEgyptianBoldItalic17Object, textEgyptianItalic14, textEgyptianItalic14Object, textEgyptianItalic15, textEgyptianItalic15Object, textEgyptianItalic17, textEgyptianItalic17Object, textSans12, textSans12Object, textSans14, textSans14Object, textSans15, textSans15Object, textSans17, textSans17Object, textSans20, textSans20Object, textSans24, textSans24Object, textSans28, textSans28Object, textSans34, textSans34Object, textSansBold12, textSansBold12Object, textSansBold14, textSansBold14Object, textSansBold15, textSansBold15Object, textSansBold17, textSansBold17Object, textSansBold20, textSansBold20Object, textSansBold24, textSansBold24Object, textSansBold28, textSansBold28Object, textSansBold34, textSansBold34Object, textSansItalic12, textSansItalic12Object, textSansItalic14, textSansItalic14Object, textSansItalic15, textSansItalic15Object, textSansItalic17, textSansItalic17Object, textSansItalic20, textSansItalic20Object, textSansItalic24, textSansItalic24Object, textSansItalic28, textSansItalic28Object, textSansItalic34, textSansItalic34Object, titlepiece42, titlepiece42Object, titlepiece50, titlepiece50Object, titlepiece70, titlepiece70Object };
